import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../../i18n/lang";

export const CookieBanner = () => {
  const { t, to } = useLang();
  const [show, setShow] = useState(false);
  useEffect(() => { setShow(!localStorage.getItem("se_cookie_ok")); }, []);
  if (!show) return null;
  const ok = () => { localStorage.setItem("se_cookie_ok", "1"); setShow(false); };
  return (
    <div role="region" aria-label="Cookie notice" data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:max-w-md z-40 bg-[#1A1A1A] text-[#FFFFFF] p-5 text-sm leading-relaxed">
      <p>{t.cookie.text}</p>
      <div className="mt-4 flex items-center gap-6">
        <button type="button" onClick={ok} data-testid="cookie-accept" className="eyebrow border border-[#FFFFFF]/50 px-4 py-2 hover:bg-[#FFFFFF] hover:text-[#1A1A1A] transition-colors duration-500">{t.cookie.ok}</button>
        <Link to={to("/cookies")} className="eyebrow underline underline-offset-4" data-testid="cookie-more">{t.cookie.more}</Link>
      </div>
    </div>
  );
};
